import type { Translations } from './types';

export const fr: Translations = {
  appName: 'Entraîneur Alphabet OTAN',
  converter: 'Convertisseur',
  quiz: 'Quiz Lettres',
  wordQuiz: 'Quiz Mots',
  settings: 'Paramètres',
  enterText: 'Entrez le texte à convertir ',
  placeholder: 'Tapez votre message ici...',
  natoAlphabet: 'Alphabet OTAN ',
  playPronunciation: 'Lire la Prononciation',
  stop: 'Arrêter',
  quickReference: 'Référence Rapide',
  showLess: 'Afficher Moins',
  viewFullAlphabet: "Voir l'Alphabet Complet →",
  copied: 'Copié!',
  copyFailed: 'Échec de la copie',
  speechNotAvailable: 'Synthèse vocale non disponible',
  voiceSettings: 'Paramètres Vocaux',
  textToSpeechVoice: 'Voix de Synthèse',
  testVoice: 'Tester la Voix',
  notifications: 'Notifications',
  spacedRepetitionReminders: 'Rappels de Répétition Espacée',
  question: 'Question',
  questionCount: '{current} sur {total}',
  reviewYourAnswers: 'Révisez Vos Réponses',
  typeNatoWordForLetter: 'Tapez le mot OTAN pour la lettre {letter}',
  startVoiceInput: 'Démarrer la saisie vocale',
  stopVoiceInput: 'Arrêter la saisie vocale',
  notificationDescription:
    'Recevez des notifications quotidiennes pour pratiquer',
  language: 'Langue',
  interfaceLanguage: "Langue de l'Interface",
  about: "À Propos de l'Entraîneur Alphabet OTAN",
  aboutDescription:
    "Apprenez l'alphabet phonétique OTAN grâce à des quiz interactifs et la répétition espacée.",
  version: 'Version 1.0.0',
  builtWith: 'Construit avec des technologies web modernes',
  currentStreak: 'Série Actuelle',
  totalSessions: 'Sessions Totales',
  accuracy: 'Précision',
  learningProgress: "Progrès d'Apprentissage",
  startQuiz: 'Commencer le Quiz',
  restartQuiz: 'Redémarrer le Quiz',
  nextQuestion: 'Question Suivante',
  submitAnswer: 'Soumettre la Réponse',
  showStats: 'Afficher les Stats',
  hideStats: 'Masquer les Stats',
  correctAnswer: 'Bonne Réponse',
  yourAnswer: 'Votre Réponse',
  correct: 'Correct',
  incorrect: 'Incorrect',
  sessionComplete: 'Session Terminée!',
  score: 'Score',
  tryAgain: 'Réessayer',
  hint: 'Indice',
  femaleVoice: 'Voix Féminine',
  maleVoice: 'Voix Masculine',
  robotVoice: 'Voix Robot',
  dailyReminders:
    "Vous recevrez des rappels quotidiens pour pratiquer l'alphabet OTAN basés sur vos progrès.",
  speakAnswer: 'Parlez votre réponse',
  voiceInputActive: 'Écoute en cours...',
  adaptiveLearning: 'Apprentissage Adaptatif',
  skipQuestion: 'Passer',
  pressEnterToSubmit: 'Appuyez sur Entrée pour soumettre',
  pressEscapeToSkip: 'Appuyez sur Échap pour passer',
  exampleAnswers: 'Exemple : "Alpha", "Bravo", "Charlie"',
  notificationsPanelTitle: 'Notifications',
  markAllAsRead: 'Marquer tout comme lu',
  noNotifications: 'Aucune notification',
  natoHints: {
    A: "Première lettre de l'alphabet grec",
    B: 'Bien joué, applaudissements!',
    C: 'C phonétique, comme le nom',
    D: 'Formation triangulaire de rivière',
    E: 'Réflexion du son',
    F: 'Danse de salon',
    G: 'Sport avec clubs et trous',
    H: 'Lieu pour passer la nuit',
    I: 'Grand pays asiatique',
    J: 'Héroïne de Shakespeare',
    K: 'Unité de poids (1000 grammes)',
    L: 'Capitale du Pérou',
    M: 'Abréviation de microphone',
    N: "Mois d'automne",
    O: "Prix de l'Académie",
    P: 'Père, informel',
    Q: 'Province canadienne',
    R: 'Personnage de Shakespeare',
    S: 'Chaîne de montagnes',
    T: 'Danse argentine',
    U: 'Même vêtement pour tous',
    V: 'Gagnant, champion',
    W: 'Boisson alcoolisée forte',
    X: 'Imagerie médicale',
    Y: 'Joueur de baseball américain',
    Z: 'Nation guerrière africaine',
  },
  // Quiz specific
  learning: 'Apprentissage',
  review: 'Révision',
  mastered: 'Maîtrisé',
  lastFiveTimes: 'Derniers 5 Temps',
  quizTimes: 'Temps de Quiz',
  bestTime: 'Meilleur Temps',
  noTimesRecorded: 'Aucun Temps Enregistré',
  // Settings
  theme: 'Thème',
  lightTheme: 'Clair',
  darkTheme: 'Sombre',
  rainbowTheme: 'Arc-en-ciel',
  systemTheme: 'Système',
  appearance: 'Apparence',
  chooseTheme: 'Choisissez votre thème préféré',
  spacedRepetitionDescription:
    "Chaque série de 10 questions s'adapte en fonction de vos performances grâce à la répétition espacée.",
  speechRate: 'Vitesse de la voix',
  pitch: 'Hauteur',
  volume: 'Volume',
  // Custom Word Input
  enterCustomWord: 'Entrer un mot personnalisé',
  enterYourWordOrPhrase: 'Entrez votre mot ou phrase...',
  useThisWord: 'Utiliser ce mot',
  // WordDisplay localization
  currentWordLabel: 'Mot Actuel',
  customWordLabel: 'Personnalisé',
  currentWordSpeech: 'Le mot actuel est : {word}',
  difficultyLabels: {
    easy: 'Facile',
    medium: 'Moyen',
    hard: 'Difficile',
  },
  categoryLabels: {
    animals: 'Animaux',
    places: 'Lieux',
    nature: 'Nature',
    technology: 'Technologie',
    home: 'Maison',
    objects: 'Objets',
    transport: 'Transport',
  },
  // NATO Input specific translations
  natoInputTitle: "Votre saisie de l'alphabet OTAN",
  natoInputPlaceholder: 'Entrez les mots OTAN : "Alpha Bravo Charlie..."',
  natoInputListening: 'Écoute...',
  natoInputLiveScore: 'Score en direct',

  // Quiz Header translations
  wordQuizInstructions:
    'Convertissez le mot ci-dessous en alphabet OTAN. Dites chaque mot OTAN séparé par des espaces ou des virgules.',

  // Quiz Actions translations
  retry: 'Réessayer',
  checkAnswer: 'Vérifier la réponse',
  newRandomWord: 'Nouveau mot aléatoire',
  cancelCustom: 'Annuler personnalisé',
  customWord: 'Mot personnalisé',

  // Quiz Results translations
  perfect: 'Parfait !',
  results: 'Résultats',
  expectedNato: 'OTAN attendu :',
  play: 'Jouer',
  letterByLetter: 'Lettre par lettre :',
};
